import { render, staticRenderFns } from "./archsTable.vue?vue&type=template&id=f203bb86&scoped=true&"
import script from "./archsTable.vue?vue&type=script&lang=js&"
export * from "./archsTable.vue?vue&type=script&lang=js&"
import style0 from "./archsTable.vue?vue&type=style&index=0&id=f203bb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f203bb86",
  null
  
)

export default component.exports